import { render, staticRenderFns } from "./PaletteIcon.vue?vue&type=template&id=76752106&"
import script from "./PaletteIcon.vue?vue&type=script&lang=js&"
export * from "./PaletteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports